import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CatalogTrackerState {
  source: string;
  records: number;
  uploadSellerSelected: string;
}

export const initialState: CatalogTrackerState = {
  source: "",
  records: 0,
  uploadSellerSelected: "",
};

export const catalogTrackerSlice = createSlice({
  name: "catalogTracker",
  initialState,
  reducers: {
    changeSource: (
      state: CatalogTrackerState,
      action: PayloadAction<string>
    ) => {
      state.source = action.payload;
    },
    addRecords: (state: CatalogTrackerState, action: PayloadAction<number>) => {
      state.records = action.payload;
    },
    changeUploadSellerSelected: (
      state: CatalogTrackerState,
      action: PayloadAction<string>
    ) => {
      state.uploadSellerSelected = action.payload;
    },
  },
});

export const { changeSource, addRecords, changeUploadSellerSelected } =
  catalogTrackerSlice.actions;
